export default __webpack_public_path__ + "static/media/mode_heat.0e634191.svg";